import {Grid, Typography,IconButton} from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {loadSkeleton,QUESTIONS_UTIL} from '../../utility';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function QuestionsBrief({briefInfo}){
    const checkForQuestionsEmptyState = (briefInfo) =>{
        if(briefInfo.report && !Array.isArray(briefInfo.report.related_questions.questions) && !Array.isArray(briefInfo.report.related_questions.related_questions_quora) && !Array.isArray(briefInfo.report.related_questions.related_questions_autocomplete)){
            return (
                <Typography>{QUESTIONS_UTIL.NO_QUESTIONS_ERROR_TEXT} "{briefInfo.report.focus_keyword}"</Typography>
            )
        }
    }

    const css = `
        .brief-questions .MuiTableCell-root{
            padding: 16px 0;
        }

        .brief-questions .MuiAccordionSummary-root, .brief-questions .MuiAccordionDetails-root{
            padding: 0;
        }
    `;

    return(
        <Grid container xs="12"  direction="row" className="brief-questions" spacing={1} style={{padding:'1rem',backgroundColor:'white'}}>
            <style>{css}</style>
            <Grid item xs="12" style={{marginBottom:'1rem',position:'sticky',position:'-webkit-sticky',top:'0'}}> 
                <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152'}}>{QUESTIONS_UTIL.HEADER}</Typography>
                <Typography variant="caption" display="block" style={{color:'#334152'}}>{QUESTIONS_UTIL.DESCRIPTION}</Typography>
            </Grid>
                <Grid item xs="12" alignItems="center" direction="row" style={{marginBottom:20}}>
                    {(!briefInfo.report) ? 
                        loadSkeleton('text')
                    : 
                        checkForQuestionsEmptyState(briefInfo)
                    }
                    {(briefInfo.report && briefInfo.report.related_questions.questions.length > 0) ?
                    <Accordion square={true} style={{boxShadow:'none'}}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="question-panel"
                        id="question-panel-id"
                        >
                        <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152',fontSize:'0.8rem'}}>{QUESTIONS_UTIL.GOOGLE_QUESTIONS_TEXT_HEADER}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TableContainer>
                            <Table aria-label="simple table">
                                <TableBody>
                                {(briefInfo.report && briefInfo.report.related_questions && Array.isArray(briefInfo.report.related_questions.questions)) ? (briefInfo.report.related_questions.questions).map((singleQuestion,index) => {
                                return(
                                    <TableRow key={singleQuestion.keyword}>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b', cursor: 'pointer'}} onClick={() => window.open(`https://www.google.com/search?q=${singleQuestion.keyword}`, "_blank")}>{singleQuestion.keyword}
                                                <IconButton size="small" aria-label="question-link" style={{float:'right'}}>
                                                    <FontAwesomeIcon icon="external-link-alt" style={{fontSize: '12px'}} />
                                                </IconButton>    
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    );
                                    }) : null
                                    }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    </Accordion>
                    : null
                    }
                    {(briefInfo.report && briefInfo.report.related_questions_quora.questions.length > 0) ? 
                    <Accordion square={true} style={{boxShadow:'none'}}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="question-panel"
                        id="question-panel-id"
                        >
                        <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152',fontSize:'0.8rem'}}>{QUESTIONS_UTIL.QUORA_QUESTIONS_TEXT_HEADER}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TableContainer>
                            <Table aria-label="simple table">
                                <TableBody>
                                {(briefInfo.report && briefInfo.report.related_questions_quora && Array.isArray(briefInfo.report.related_questions_quora.questions)) ? 
                                    (briefInfo.report.related_questions_quora.questions).map((singleQuestion,index) => {
                                return(
                                    <TableRow key={singleQuestion.keyword}>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b', cursor: 'pointer'}} onClick={() => window.open(`${singleQuestion.link}`, "_blank")}>{singleQuestion.question}
                                                <IconButton size="small" aria-label="question-link" style={{float:'right'}}>
                                                    <FontAwesomeIcon icon="external-link-alt" style={{fontSize: '12px'}} />
                                                </IconButton>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    );
                                    }) : null
                                    }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    </Accordion>
                    : null}
                    {(briefInfo.report && briefInfo.report.related_questions_autocomplete.questions.length > 0) ? 
                        <Accordion square={true} style={{boxShadow:'none'}}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="question-panel"
                        id="question-panel-id"
                        >
                        <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152',fontSize:'0.8rem'}}>{QUESTIONS_UTIL.AUTOCOMPLETE_QUESTIONS_TEXT_HEADER}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TableContainer>
                            <Table aria-label="simple table">
                                <TableBody>
                                {(briefInfo.report && briefInfo.report.related_questions_autocomplete && Array.isArray(briefInfo.report.related_questions_autocomplete.questions)) ? 
                                    (briefInfo.report.related_questions_autocomplete.questions).map((singleQuestion,index) => {
                                return(
                                    <TableRow key={singleQuestion.keyword}>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b', cursor: 'pointer'}} onClick={() => window.open(`https://www.google.com/search?q=${singleQuestion.keyword}`, "_blank")}>{singleQuestion.keyword}?
                                                <IconButton size="small" aria-label="question-link" style={{float:'right'}}>
                                                    <FontAwesomeIcon icon="external-link-alt" style={{fontSize: '12px'}} />
                                                </IconButton>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    );
                                }) : null
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    </Accordion>
                    : null }
            </Grid>
        </Grid>
    );

}

export default QuestionsBrief;